import React, { useCallback } from 'react';

import { Box } from '@mui/material';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import LoadMoreFeedback from '../../../../components/reusable/load-more-feedback/LoadMoreFeedback';
import { EXERCISE_FILTERS_PAGE_KEYS } from '../exercise-filters';
import ExerciseList from '../exercise-list/ExerciseList';
import { useMyExercisesPage } from './useMyExercisesPage';

interface IMyExercisesProps {
  setPlanDialogOpen: (open: boolean) => void;
}

const MyExercises = (props: IMyExercisesProps) => {
  const { setPlanDialogOpen } = props;
  const {
    exercises,
    isLoading,
    error,
    hasData,
    addNewExerciseClicked,
    refetch,
    footerRef,
    handleQueryChange,
    handleRetry,
    isFetching,
  } = useMyExercisesPage({
    setPlanDialogOpen,
  });

  const handleRetryClick = useCallback(() => {
    handleRetry();
  }, [handleRetry]);

  useRegisterPageRefreshHandler(refetch);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading,
    hasData,
    onRetry: handleRetryClick,
  });

  return (
    <ExerciseList
      exercises={exercises}
      filtersPageKey={EXERCISE_FILTERS_PAGE_KEYS.my}
      isLoading={isLoading}
      addNewExerciseClicked={addNewExerciseClicked}
      disableClientFilter
      onQueryChange={handleQueryChange}
      listFooter={
        <>
          <LoadMoreFeedback
            error={error}
            isFetching={isFetching}
            onRetry={handleRetryClick}
          />
          <Box ref={footerRef} mb={1} />
        </>
      }
    />
  );
};

export default MyExercises;
